@if (showForm()) {
  <article [class]="[dialogRef ? 'modal-wrapper' : 'sheet-wrapper']" class="primary-modal native" [formGroup]="formGroup">
    <section mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
      <span>{{ selectedData?.title ?? ("DOCUMENTSPLUS.LBL_ATTACH" | transloco: { count: selectedData?.ids?.length }) }}</span>
      <button mat-icon-button type="button" (click)="close(false, true)" [matTooltip]="'APP.BTN_CANCEL' | transloco" [disabled]="formGroup?.disabled">
        <mat-icon [fontSet]="'' | function: userDefinedIconFontSet | async" [fontIcon]="icons.CLOSE"></mat-icon>
      </button>
    </section>

    <section mat-dialog-content>
      <div class="documents-plus-attach">
        <!-- Only show if no appId is passed in and if more than one application exists. Default will be first in list -->
        @if (applications?.length > 1 && !selectedData?.applicationId) {
          <mat-form-field>
            <mat-label>{{ "DOCUMENTSPLUS.LBL_APPLICATION" | transloco }}</mat-label>
            <mat-select
              formControlName="applicationId"
              [required]="isRequired('applicationId')"
              (selectionChange)="setTabApplicationId(); refreshApplicationValues()"
            >
              @for (app of applications; track app.applicationId) {
                <mat-option [value]="app.applicationId">
                  {{ app.shortDescription }}
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getError(formGroup, "applicationId") | transloco }}</mat-error>
          </mat-form-field>
        }

        <!-- Id -->
        @if (!dplusConfigService?.dplusIds()?.length) {
          <mat-form-field>
            <mat-label>{{ "" | function: idLabel }}</mat-label>
            <input
              matInput
              formControlName="companyNumber"
              [required]="isRequired('companyNumber')"
              [appAutoFocus]="!dplusConfigService?.appConfig()?.isPositionToIndex"
              appFormFieldTrim
              [debounce]="0"
            />
            <mat-error>{{ getError(formGroup, "companyNumber") | transloco }}</mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field>
            <mat-label>{{ "" | function: idLabel }}</mat-label>
            <mat-select formControlName="companyNumber" [appAutoFocus]="!dplusConfigService?.appConfig()?.isPositionToIndex">
              @for (id of dplusConfigService?.dplusIds(); track id) {
                <mat-option [value]="id.id">
                  @if (id.id) {
                    {{ id.id + " - " + id.description }}
                  } @else {
                    {{ id.description }}
                  }
                </mat-option>
              }
            </mat-select>
            <mat-error>{{ getError(formGroup, "companyNumber") | transloco }}</mat-error>
          </mat-form-field>
        }

        <!-- Dplus has configured id's -->
        <!-- Index -->
        <mat-form-field>
          <mat-label>{{ "" | function: indexLabel }}</mat-label>
          <input
            matInput
            formControlName="index"
            [required]="isRequired('index')"
            [appAutoFocus]="dplusConfigService?.appConfig()?.isPositionToIndex === true"
            appFormFieldTrim
            [debounce]="0"
          />
          <mat-error>{{ getError(formGroup, "index") | transloco }}</mat-error>
        </mat-form-field>

        <!-- Document Type Selection (MyReports) -->
        @if (showDocumentType) {
          <!-- Document Types -->
          <app-type-ahead
            [data]="documentTypes"
            [controlName]="'documentType'"
            [form]="formGroup"
            [valueName]="'type'"
            [label]="'DOCUMENTSPLUS.LBL_DOC_TYPES' | transloco"
            [displayName]="'description'"
            [displayName2]="'type'"
            (displayedValue)="onDocumentTypeChange($event)"
          ></app-type-ahead>
        }

        <!-- Document Type Description -->
        @if (selectedData?.documentTypeDescription && !showDocumentType) {
          <mat-form-field>
            <mat-label>{{ "DOCUMENTSPLUS.LBL_DOC_TYPES" | transloco }}</mat-label>
            <input matInput formControlName="documentTypeDescription" [required]="isRequired('documentTypeDescription')" />
            <mat-error>{{ getError(formGroup, "documentTypeDescription") | transloco }}</mat-error>
          </mat-form-field>
        }

        <!-- Checkboxes -->
        @if (canDelete || canAutoDelete) {
          <div class="in-basket-attach--checkbox">
            <!-- Delete In-Basket item after attach -->
            <mat-checkbox formControlName="deleteDoc">{{
              "DOCUMENTSPLUS.LBL_DELETE_INBASKET" | transloco: { count: selectedData?.ids?.length }
            }}</mat-checkbox>
          </div>
        }
      </div>
    </section>

    <!-- Actions -->
    <section mat-dialog-actions>
      <button
        mat-stroked-button
        class="button__primary--primary"
        [disabled]="formGroup.invalid || formGroup.disabled"
        appClickStop
        (debounceClick)="save()"
      >
        {{ "DOCUMENTSPLUS.BTN_ATTACH" | transloco }}
      </button>
      <button mat-stroked-button type="button" (click)="close(false, true)" [disabled]="formGroup.disabled">
        {{ "APP.BTN_CANCEL" | transloco }}
      </button>
    </section>
  </article>
}
